export function flipLane(event) 
{
  var lane = event.target.closest('.react-trello-lane');
  var backPage = lane.querySelector('.NormalLaneBack');
  var frontPage = lane.querySelector('.NormalLaneFront')

  if(lane.classList.contains('FlipBack'))
  {
    
    lane.classList.remove('FlipBack');
    sleep(500).then(() => { 
                             lane.style.padding = "10px";
                              backPage.classList.remove('Show');
                              backPage.classList.add('Hide');
                              frontPage.style.display = 'block';
                              frontPage.classList.remove('Hide');
                              
                          });  
  }
  else
  {
    lane.classList.add('FlipBack');
    sleep(500).then(() => { 
                              lane.style.padding = "0px";
                              backPage.classList.add('Show');
                              backPage.classList.remove('Hide');
                              frontPage.style.display = 'none';
                              frontPage.classList.add('Hide');
                          });
  }
}

function sleep(ms) 
{
  return new Promise(resolve => setTimeout(resolve, ms));
}